// ~/app/javascript/something/jspsych-attention-check.js

// On peut importer des symboles depuis "jspsych" si nécessaire :
import { JsPsych, ParameterType } from "jspsych";

/**
 * Infos du plugin (nom, paramètres, etc.)
 * Doc: https://www.jspsych.org/7.3/plugins/creating-plugins/
 */
const info = {
  name: "attention-check",
  parameters: {
    timing_response: {
      type: ParameterType.INT,
      default: 180000
    },
    response_ends_trial: {
      type: ParameterType.BOOL,
      default: true
    },
    timing_post_trial: {
      type: ParameterType.INT,
      default: 200
    },
    trial_id: {
      type: ParameterType.STRING,
      default: null
    }
  }
};

/**
 * Classe du plugin pour jsPsych v7
 */
class AttentionCheckPlugin {
  static info = info;

  constructor(jsPsych) {
    this.jsPsych = jsPsych;
  }

  trial(display_element, trial) {
    display_element.innerHTML = "<p>Attention Check: Appuyez sur n'importe quelle touche pour continuer</p>";

    let response = { rt: null, key: null };

    let keyboardListener = this.jsPsych.pluginAPI.getKeyboardResponse({
      callback_function: (info) => {
        response.rt = info.rt;
        response.key = info.key;
        endTrial();
      },
      valid_responses: this.jsPsych.ALL_KEYS
    });

    const endTrial = () => {
      this.jsPsych.pluginAPI.cancelKeyboardResponse(keyboardListener);
      display_element.innerHTML = "";
      this.jsPsych.finishTrial(response);
    };

    if (trial.timing_response !== null) {
      this.jsPsych.pluginAPI.setTimeout(endTrial, trial.timing_response);
    }
  }
}

export default AttentionCheckPlugin;
